import { useMemo } from 'react'

import { useAuth } from '../useAuth/useAuth'

import { getCountryCodeFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import countries from '@percent/workplace-giving/i18n/countries'

type UseQueryCountryCodeValidationProps = Readonly<{
  code: string | undefined
}>

export const useQueryCountryCodeValidation = ({ code }: UseQueryCountryCodeValidationProps): Readonly<string> => {
  const { state: authState } = useAuth()

  return useMemo(() => {
    if ((code && countries.isValid(code)) || code === '') {
      return code
    }

    const codeFromAuthState = getCountryCodeFromAuthState(authState)

    if (codeFromAuthState && countries.isValid(codeFromAuthState)) {
      return codeFromAuthState
    }

    return ''
  }, [authState, code])
}
